var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "login-component",
      class: { "not-initial-form": !_vm.initialForm }
    },
    [
      _vm.disableJoin ? _c("popup-join-dialog") : _vm._e(),
      _vm._v(" "),
      !_vm.mobileBigAndBelow &&
      _vm.brandLayout !== "generic" &&
      _vm.brandKey !== "circa" &&
      _vm.brandKey !== "sb" &&
      _vm.brandKey !== "mav" &&
      _vm.brandKey !== "qcasino" &&
      _vm.brandKey !== "pr"
        ? _c(
            "div",
            { staticClass: "loginDialogIntro" },
            [
              _c("div", { staticClass: "login-intro" }, [
                _c("div", { staticClass: "small" }, [
                  _vm._v(_vm._s(_vm.$t("Login.Intro.Small")))
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "big",
                  domProps: { innerHTML: _vm._s(_vm.$t("Login.Intro.Big")) }
                })
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "joinNow",
                  on: {
                    click: function($event) {
                      return _vm.goToRegistrationPage()
                    }
                  }
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("MyAccount.JoinNow")))])]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "loginHolder" },
        [
          _c(
            "v-layout",
            { attrs: { "align-center": "", "login-header": "" } },
            [
              _c(
                "v-flex",
                { staticClass: "logo" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/" } },
                    [
                      _c("logo", {
                        attrs: {
                          mode: _vm.brandKey === "rw" ? "dark" : "light",
                          name:
                            _vm.brandKey === "dn" || _vm.brandKey === "dnw"
                              ? "extend"
                              : ""
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.brandKey !== "dn" && _vm.brandKey !== "dnw"
                ? _c(
                    "v-flex",
                    { staticClass: "close" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "close",
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.closeLoginDialog()
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          (_vm.brandLayout === "generic" ||
            _vm.brandKey === "sb" ||
            _vm.brandKey === "mav") &&
          _vm.initialForm &&
          _vm.mobileBigAndBelow &&
          !_vm.formSubmitSppiner &&
          ((!_vm.biometricsSettignsParam &&
            _vm.biometricsAvailability &&
              _vm.biometricsAvailability.biometrics === "DATA") ||
            (_vm.biometricsSettignsParam &&
              _vm.faceIDstate &&
              _vm.biometricsSettings &&
                _vm.biometricsSettings.biometrics_display === "true" &&
              _vm.biometricsAvailability &&
                _vm.biometricsAvailability.biometrics === "DATA"))
            ? _c(
                "div",
                { staticClass: "buttons faceBtn" },
                [
                  _vm.brandKey === "mav"
                    ? _c("img", {
                        attrs: {
                          src: "/static/brand-img/mav/login_face_id.svg",
                          alt: ""
                        },
                        on: {
                          click: function($event) {
                            return _vm.readBiometricsData()
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-white primary-btn-blue",
                      attrs: { block: "" },
                      on: {
                        click: function($event) {
                          return _vm.readBiometricsData()
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "faceId" }, [
                        _vm._v(_vm._s(_vm.biometricsAvailability.btn_text))
                      ])
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.enterPinTitleVisible &&
          (_vm.brandLayout === "generic" ||
            _vm.brandKey === "circa" ||
            _vm.brandKey === "sb" ||
            _vm.brandKey === "mav" ||
            _vm.brandKey === "qcasino" ||
            _vm.brandKey === "pr")
            ? _c("div", { staticClass: "loginTitle" }, [
                _vm._v(_vm._s(_vm.$t("Login.Title")))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.enterPinTitleVisible
            ? _c("div", { staticClass: "loginTitle" }, [
                _vm._v(_vm._s(_vm.$t("Login.EnterPin.Title")))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.brandKey === "qcasino" || _vm.brandKey === "pr"
            ? _c("div", { staticClass: "profile-img" }, [
                _vm.brandKey === "qcasino"
                  ? _c("img", {
                      attrs: {
                        src: "/static/brand-img/qcasino/profile-white.svg",
                        alt: ""
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.brandKey === "pr"
                  ? _c("img", {
                      attrs: {
                        src: "/static/brand-img/pr/profile-blue.svg",
                        alt: ""
                      }
                    })
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.initialForm
            ? _c(
                "v-form",
                {
                  staticClass: "form-normal",
                  attrs: { autocomplete: "off" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.get2FA()
                    }
                  }
                },
                [
                  _vm.accountIsLocked && _vm.brandKey === "sb"
                    ? _c("div", {
                        staticClass: "lockedAccount",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("MyAccount.PasswordPolicy.SB.Blocked")
                          )
                        }
                      })
                    : _vm.accountIsLocked
                    ? _c("div", { staticClass: "lockedAccount" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t(
                                "MyAccount.PasswordPolicy.Locked.FirstPart"
                              )
                            ) +
                            "\n        "
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "here",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.go2ChangePasswordPage.apply(
                                  null,
                                  arguments
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "MyAccount.PasswordPolicy.Locked.SecondPart"
                                )
                              )
                            )
                          ]
                        ),
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t(
                                "MyAccount.PasswordPolicy.Locked.ThirdPart"
                              )
                            ) +
                            "\n      "
                        )
                      ])
                    : _vm.noSA && _vm.type2fa && !_vm.sent2fa
                    ? _c(
                        "p",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.loginErrorMessage === "ChannelDoesNotExist",
                              expression:
                                "loginErrorMessage==='ChannelDoesNotExist'"
                            }
                          ],
                          staticClass: "lockedAccount noChannel"
                        },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "MyAccount.Login.2fa.Sent.ChannelDoesNotExist" +
                                    _vm.getChannelTranslationSuffix()
                                )
                              )
                            }
                          })
                        ]
                      )
                    : _vm.noSA
                    ? _c(
                        "p",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.loginErrorMessage,
                              expression: "loginErrorMessage"
                            }
                          ],
                          staticClass: "error"
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.loginErrorMessage) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$t("Login.Account.Activation") && _vm.brandKey === "boyd"
                    ? _c("p", { staticClass: "activate-account" }, [
                        _vm._v(_vm._s(_vm.$t("Login.Account.Activation")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-text-field", {
                    ref: "username",
                    staticClass: "username",
                    attrs: {
                      type: "text",
                      required: "",
                      id: "username",
                      name: "username",
                      label: _vm.usernameLabel
                    },
                    on: { input: _vm.clearPasswordField },
                    model: {
                      value: _vm.loginFields.username,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.loginFields,
                          "username",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "loginFields.username"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _vm.loginUsernameType === "UN" &&
                    _vm.errorMessages.userNameSymbol
                      ? _c("div", {
                          staticClass: "errormsg",
                          attrs: { id: "err_msg_username_symbol" },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("Account.Join.ErrorMsg.UserNameSymbol")
                            )
                          }
                        })
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("v-text-field", {
                    staticClass: "password",
                    attrs: {
                      type: _vm.loginFields.showPassword ? "text" : "password",
                      required: "",
                      id: "password",
                      name: "password",
                      label: _vm.$t("Login.Password")
                    },
                    model: {
                      value: _vm.loginFields.password,
                      callback: function($$v) {
                        _vm.$set(_vm.loginFields, "password", $$v)
                      },
                      expression: "loginFields.password"
                    }
                  }),
                  _vm._v(" "),
                  _vm.brandKey !== "circa" &&
                  _vm.brandKey !== "sb" &&
                  _vm.brandKey !== "mav"
                    ? _c(
                        "span",
                        {
                          staticClass: "show_hide",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.toggleShowPassword()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.loginFields.showPassword ? "Hide" : "Show"
                            )
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.brandKey === "qcasino" || _vm.brandKey === "pr"
                    ? _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "float-right forgotPass",
                              attrs: { xs12: "" }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { target: "_self" },
                                  on: {
                                    click: function($event) {
                                      return _vm.goToForgottenPasswordPage()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { attrs: { id: "qa-forgotPass" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("MyAccount.ForgotPass"))
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.brandKey === "circa" ||
                  _vm.brandKey === "sb" ||
                  _vm.brandKey === "mav"
                    ? _c(
                        "span",
                        {
                          staticClass: "show_hide",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.toggleShowPassword()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.loginFields.showPassword
                                ? "Hide Password"
                                : "Show Password"
                            )
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.formSubmitSppiner
                    ? _c("div", [_c("circle-loader")], 1)
                    : _vm._e(),
                  _vm._v(" "),
                  (_vm.brandKey === "qcasino" || _vm.brandKey === "pr") &&
                  !_vm.formSubmitSppiner
                    ? _c(
                        "v-flex",
                        {
                          staticClass: "float-left forgotPass dont-have-acc",
                          attrs: { xs12: "" }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("MyAccount.HaveYouAnAccount")))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isFitForPLayEnabled
                    ? _c(
                        "div",
                        { staticClass: "float-left forgotPass" },
                        [
                          _c("v-checkbox", {
                            staticClass: "cxFitForPlay",
                            attrs: { label: _vm.$t("MyAccount.FitForPlay") },
                            model: {
                              value: _vm.checkboxFFP,
                              callback: function($$v) {
                                _vm.checkboxFFP = $$v
                              },
                              expression: "checkboxFFP"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.formSubmitSppiner
                    ? _c(
                        "div",
                        { staticClass: "buttons" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "primary-btn-blue login",
                              attrs: {
                                type: "submit",
                                disabled: _vm.isLoginButtonDisabled,
                                block: "",
                                id: "login_btn_dialog"
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("MyAccount.LogIn")))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm.brandKey === "dn" ||
                          _vm.brandKey === "dnw" ||
                          _vm.brandKey === "qcasino" ||
                          _vm.brandKey === "pr"
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "join-now",
                                  on: {
                                    click: function($event) {
                                      return _vm.joinAction()
                                    }
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("MyAccount.JoinNow")))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.formSubmitSppiner && _vm.brandKey === "circa"
                    ? _c("div", { staticClass: "buttons circa_buttons" }, [
                        _c(
                          "div",
                          { staticClass: "btnsHolder" },
                          [
                            _c("span", { staticClass: "v-btn need-account" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("MyAccount.NeedAccount")))
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                staticClass: "join-now",
                                on: {
                                  click: function($event) {
                                    return _vm.goToRegistrationPage()
                                  }
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("MyAccount.JoinNow")))
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.biometricsSettignsParam &&
                  !_vm.formSubmitSppiner &&
                  _vm.mobileBigAndBelow &&
                  _vm.biometricsSettings &&
                    _vm.biometricsSettings.biometrics_display === "true"
                    ? _c("v-switch", {
                        staticClass: "faceIdSwitch",
                        attrs: {
                          color: _vm.switchColor,
                          label: _vm.biometricsSettings.btn_text
                        },
                        on: {
                          change: function($event) {
                            return _vm.faceIdChangeState(_vm.faceIDstate)
                          }
                        },
                        model: {
                          value: _vm.faceIDstate,
                          callback: function($$v) {
                            _vm.faceIDstate = $$v
                          },
                          expression: "faceIDstate"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  (!_vm.formSubmitSppiner && _vm.brandKey === "sb") ||
                  _vm.brandKey === "mav" ||
                  _vm.brandLayout === "generic"
                    ? _c("div", { staticClass: "buttons sb_buttons" }, [
                        _c(
                          "div",
                          { staticClass: "btnsHolder" },
                          [
                            _vm.brandKey === "sb"
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "join-now",
                                    on: {
                                      click: function($event) {
                                        return _vm.joinAction()
                                      }
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("MyAccount.CreateAccount")
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.brandKey === "mav" ||
                            _vm.brandLayout === "generic"
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "primary-btn-blue join-now",
                                    attrs: { type: "submit", block: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.joinAction()
                                      }
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("MyAccount.JoinNow"))
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.brandKey === "sb" && _vm.state === "NJ"
                          ? _c("div", { staticClass: "rg" }, [
                              _c("span", {
                                staticClass: "header-txt",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("Login.InfoMessage." + _vm.state)
                                  )
                                }
                              })
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.brandLayout !== "generic" &&
                  _vm.brandKey !== "sb" &&
                  _vm.brandKey !== "mav" &&
                  _vm.initialForm &&
                  _vm.mobileBigAndBelow &&
                  !_vm.formSubmitSppiner &&
                  ((!_vm.biometricsSettignsParam &&
                    _vm.biometricsAvailability &&
                      _vm.biometricsAvailability.biometrics === "DATA") ||
                    (_vm.biometricsSettignsParam &&
                      _vm.faceIDstate &&
                      _vm.biometricsSettings &&
                        _vm.biometricsSettings.biometrics_display === "true" &&
                      _vm.biometricsAvailability &&
                        _vm.biometricsAvailability.biometrics === "DATA"))
                    ? _c(
                        "div",
                        { staticClass: "buttons faceBtn" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn-white",
                              attrs: { block: "" },
                              on: {
                                click: function($event) {
                                  return _vm.readBiometricsData()
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "faceId" }, [
                                _vm._v(
                                  _vm._s(_vm.biometricsAvailability.btn_text)
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.brandKey === "qcasino" || _vm.brandKey === "pr"
                    ? _c("div", { staticClass: "login-footer" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.brandKey !== "qcasino" && _vm.brandKey !== "pr"
                    ? _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "float-right forgotPass",
                              attrs: { xs12: "" }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { target: "_self" },
                                  on: {
                                    click: function($event) {
                                      return _vm.goToForgottenPasswordPage()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { attrs: { id: "qa-forgotPass" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("MyAccount.ForgotPass"))
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.brandKey === "dn" || _vm.brandKey === "dnw"
                            ? _c(
                                "v-flex",
                                {
                                  staticClass: "float-right forgotPass",
                                  attrs: { xs12: "" }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("MyAccount.HaveYouAnAccount")
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.resetPwdForm
            ? _c(
                "v-form",
                { staticClass: "form-normal" },
                [
                  _vm.resetPwdErrorMessage
                    ? _c("p", { staticClass: "error" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.resetPwdErrorMessage) +
                            "\n      "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.resetPwdErrorMessage && _vm.pwdPolicy === "reset"
                    ? _c(
                        "p",
                        {
                          staticClass: "resetpwd-intro",
                          class: { "activate-account": _vm.brandKey === "boyd" }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$t("MyAccount.PasswordPolicy.ResetPassword")
                              ) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-text-field", {
                    ref: "newPassword",
                    staticClass: "password",
                    attrs: {
                      type: _vm.showNewPassword ? "text" : "password",
                      required: "",
                      id: "newPassword",
                      name: "newPassword",
                      label: _vm.$t("Account.ChangePassword.NewPassword"),
                      maxlength: _vm.vldPasswordMaxLength
                    },
                    model: {
                      value: _vm.newPassword,
                      callback: function($$v) {
                        _vm.newPassword = $$v
                      },
                      expression: "newPassword"
                    }
                  }),
                  _vm._v(" "),
                  _vm.brandKey !== "circa" && _vm.brandKey !== "sb"
                    ? _c(
                        "span",
                        {
                          staticClass: "show_hide",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.toggleShowNewPassword()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.showNewPassword ? "Hide" : "Show"))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.brandKey === "circa" || _vm.brandKey === "sb"
                    ? _c(
                        "span",
                        {
                          staticClass: "show_hide",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.toggleShowNewPassword()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.showNewPassword
                                ? "Hide Password"
                                : "Show Password"
                            )
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "account-page ctsform form_msgs" }, [
                    _vm.errorMessages.newPasswordMissing.val
                      ? _c(
                          "div",
                          {
                            staticClass: "vmsg invalid",
                            class: { invmsg: _vm.brandKey !== "boyd" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Account.ChangePassword.ErrorMessages.NewPasswordMissing"
                                )
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.errorMessages.newPasswordSame.val
                      ? _c(
                          "div",
                          {
                            staticClass: "vmsg invalid",
                            class: { invmsg: _vm.brandKey !== "boyd" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Account.ChangePassword.ErrorMessages.SamePassword"
                                )
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.errorMessages.newPasswordStrength.val
                      ? _c("div", {
                          staticClass: "vmsg invalid",
                          class: { invmsg: _vm.brandKey !== "boyd" },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("Account.Join.ErrorMsg.PassStrength", {
                                pwdMinLength: _vm.vldPasswordMinLength
                              })
                            )
                          }
                        })
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("v-text-field", {
                    ref: "confirmNewPassword",
                    staticClass: "password",
                    attrs: {
                      type: _vm.showConfirmPassword ? "text" : "password",
                      required: "",
                      id: "confirmNewPassword",
                      name: "confirmNewPassword",
                      label: _vm.$t(
                        "Account.ChangePassword.ConfirmNewPassword"
                      ),
                      maxlength: _vm.vldPasswordMaxLength
                    },
                    model: {
                      value: _vm.confirmNewPassword,
                      callback: function($$v) {
                        _vm.confirmNewPassword = $$v
                      },
                      expression: "confirmNewPassword"
                    }
                  }),
                  _vm._v(" "),
                  _vm.brandKey !== "circa" && _vm.brandKey !== "sb"
                    ? _c(
                        "span",
                        {
                          staticClass: "show_hide",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.toggleShowConfirmPassword()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.showConfirmPassword ? "Hide" : "Show")
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.brandKey === "circa" || _vm.brandKey === "sb"
                    ? _c(
                        "span",
                        {
                          staticClass: "show_hide",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.toggleShowConfirmPassword()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.showConfirmPassword
                                ? "Hide Password"
                                : "Show Password"
                            )
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "account-page ctsform form_msgs" }, [
                    _vm.errorMessages.confirmNewPasswordMissing.val
                      ? _c(
                          "div",
                          {
                            staticClass: "vmsg invalid",
                            class: { invmsg: _vm.brandKey !== "boyd" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Account.ChangePassword.ErrorMessages.ConfirmNewPassword.Missing"
                                )
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.errorMessages.confirmedNewPasswordNotSame.val
                      ? _c(
                          "div",
                          {
                            staticClass: "vmsg invalid",
                            class: { invmsg: _vm.brandKey !== "boyd" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Account.ChangePassword.ErrorMessages.ConfirmNewPassword.NotSame"
                                )
                              )
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.pwdResetMode === 0
                    ? _c("div", { staticClass: "ctsform nosa-ssn4-dob" }, [
                        _c(
                          "div",
                          {
                            staticClass: "control-block",
                            class: { filled: _vm.ssn4 }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.ssn4,
                                  expression: "ssn4"
                                }
                              ],
                              attrs: {
                                type: "text",
                                inputmode: "numeric",
                                autocomplete: "off",
                                maxlength: 4
                              },
                              domProps: { value: _vm.ssn4 },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.ssn4 = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("label", { staticClass: "control-label" }, [
                              _vm._v(_vm._s(_vm.$t("Account.Join.Last4SSN")))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "control-block",
                            class: { filled: _vm.dateOfBirth },
                            on: { click: _vm.onDateBirth }
                          },
                          [
                            _c(
                              "v-menu",
                              {
                                ref: "datePickerMenu",
                                attrs: {
                                  "close-on-click": false,
                                  "close-on-content-click": false,
                                  "nudge-right": 0,
                                  "return-value": _vm.dateOfBirth,
                                  lazy: "",
                                  transition: "scale-transition",
                                  "offset-y": "",
                                  "full-width": "",
                                  "min-width": "290px",
                                  "z-index": "250!important"
                                },
                                on: {
                                  "update:returnValue": function($event) {
                                    _vm.dateOfBirth = $event
                                  },
                                  "update:return-value": function($event) {
                                    _vm.dateOfBirth = $event
                                  }
                                },
                                model: {
                                  value: _vm.datePickerMenu,
                                  callback: function($$v) {
                                    _vm.datePickerMenu = $$v
                                  },
                                  expression: "datePickerMenu"
                                }
                              },
                              [
                                _c("template", { slot: "activator" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.trim",
                                        value: _vm.formattedDate,
                                        expression: "formattedDate",
                                        modifiers: { trim: true }
                                      }
                                    ],
                                    attrs: {
                                      type: "text",
                                      id: "dateOfBirth",
                                      autocomplete: "off",
                                      readonly: "",
                                      name: "reg-dob"
                                    },
                                    domProps: { value: _vm.formattedDate },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.formattedDate = $event.target.value.trim()
                                      },
                                      blur: function($event) {
                                        return _vm.$forceUpdate()
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    { staticClass: "control-label" },
                                    [_vm._v(_vm._s(_vm.$t("Account.Join.DOB")))]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("v-date-picker", {
                                  ref: "picker",
                                  attrs: {
                                    max: _vm.maxDate,
                                    "no-title": "",
                                    scrollable: ""
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.checkDateOfBirth()
                                    }
                                  },
                                  model: {
                                    value: _vm.dateOfBirth,
                                    callback: function($$v) {
                                      _vm.dateOfBirth = $$v
                                    },
                                    expression: "dateOfBirth"
                                  }
                                })
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.resetPwdSubmitSppiner
                    ? _c("div", [_c("circle-loader")], 1)
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.resetPwdSubmitSppiner
                    ? _c(
                        "div",
                        { staticClass: "buttons" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "primary-btn-blue",
                              attrs: {
                                disabled:
                                  _vm.isChangePasswordButtonDisabled ||
                                  (_vm.pwdResetMode === 0 &&
                                    (!_vm.dateOfBirth || _vm.ssn4IsInvalid)),
                                block: ""
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.resetPwdSA()
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("MyAccount.Proceed")))
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          (_vm.SAPINOnLogin &&
            (!_vm.resetPwd ||
              (_vm.resetPwd &&
                _vm.showSALoginAfterResetPwd &&
                !_vm.showResetPwdSAForm))) ||
          (_vm.showResetPwdSAForm && _vm.ResetPwdSAPINOnLogin)
            ? _c(
                "div",
                { staticClass: "account-page ctsform sa" },
                [
                  _vm.accountIsLocked && _vm.brandKey === "sb"
                    ? _c("div", {
                        staticClass: "lockedAccount",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("MyAccount.PasswordPolicy.SB.Blocked")
                          )
                        }
                      })
                    : _vm.accountIsLocked
                    ? _c("div", { staticClass: "lockedAccount" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t(
                                "MyAccount.PasswordPolicy.Locked.FirstPart"
                              )
                            ) +
                            "\n        "
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "here",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.go2ChangePasswordPage.apply(
                                  null,
                                  arguments
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "MyAccount.PasswordPolicy.Locked.SecondPart"
                                )
                              )
                            )
                          ]
                        ),
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t(
                                "MyAccount.PasswordPolicy.Locked.ThirdPart"
                              )
                            ) +
                            "\n      "
                        )
                      ])
                    : _vm.showResetPwdSAForm &&
                      _vm.overridenPINExceptionResetPwd
                    ? _c("p", { staticClass: "error" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.overridenPINExceptionResetPwd) +
                            "\n      "
                        )
                      ])
                    : _vm.showResetPwdSAForm && _vm.resetPwdErrorMessage
                    ? _c("p", { staticClass: "error" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.resetPwdErrorMessage) +
                            "\n      "
                        )
                      ])
                    : _vm.overridenPINException
                    ? _c("p", { staticClass: "error" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.overridenPINException) +
                            "\n      "
                        )
                      ])
                    : _vm.loginErrorMessage
                    ? _c("p", { staticClass: "error" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.loginErrorMessage) }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.resetPwd && _vm.showSALoginAfterResetPwd
                    ? _c(
                        "p",
                        {
                          staticClass: "resetpwd-intro-sa",
                          class: { "activate-account": _vm.brandKey === "boyd" }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$t(
                                  "MyAccount.PasswordPolicy.ResetPasswordLogin.UseSA"
                                )
                              ) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm.showResetPwdSAForm && _vm.ResetPwdSAPINOnLogin
                    ? _c(
                        "p",
                        {
                          staticClass: "resetpwd-intro-sa",
                          class: { "activate-account": _vm.brandKey === "boyd" }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$t(
                                  "MyAccount.PasswordPolicy.ResetPassword.UseSA"
                                )
                              ) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showResetPwdSAForm && _vm.ResetPwdSAPINOnLogin
                    ? _c("p", [
                        _vm._v(_vm._s(_vm.$t("MyAccount.SA.Pin.Label")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pin container" },
                    [
                      _vm.showResetPwdSAForm && _vm.ResetPwdSAPINOnLogin
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "primary-btn-blue",
                              attrs: { type: "submit" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.sendPINByUsernameAndPassword(
                                    !_vm.showResetPwdSAForm
                                  )
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("MyAccount.SA.Pin.Send")))
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "control-block pin",
                          class: { filled: _vm.pin }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.pin,
                                expression: "pin",
                                modifiers: { trim: true }
                              }
                            ],
                            attrs: {
                              type: "text",
                              autocomplete: "one-time-code",
                              id: "single-factor-code-text-field",
                              maxlength: "50"
                            },
                            domProps: { value: _vm.pin },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.pin = $event.target.value.trim()
                              },
                              blur: function($event) {
                                return _vm.$forceUpdate()
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.showResetPwdSAForm && _vm.ResetPwdSAPINOnLogin
                            ? _c("label", { staticClass: "control-label" }, [
                                _vm._v(_vm._s(_vm.$t("MyAccount.SA.Pin.Code")))
                              ])
                            : _c("label", { staticClass: "control-label" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("MyAccount.Login.2fa.Pin.Label")
                                  )
                                )
                              ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !(_vm.showResetPwdSAForm && _vm.ResetPwdSAPINOnLogin)
                    ? _c("div", [
                        _vm.type2fa &&
                        (_vm.type2fa.toLowerCase() === "totp2fa" ||
                          _vm.type2fa.toLowerCase() === "totp")
                          ? _c("span", [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t(
                                      "MyAccount.Login.2fa.Sent.Pin.AuthyApp"
                                    )
                                  )
                                }
                              })
                            ])
                          : _vm.type2fa &&
                            (_vm.type2fa.toLowerCase() === "2fa" ||
                              _vm.type2fa.toLowerCase() === "pin")
                          ? _c("span", [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("MyAccount.Login.2fa.Sent.Pin", {
                                      channel: _vm.getChannel(),
                                      sendAgain: !_vm.resendPinVisible
                                        ? "."
                                        : " " +
                                          _vm.$t(
                                            "MyAccount.Login.2fa.Sent.Pin.Again.Or"
                                          )
                                    })
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _vm.resendPinVisible
                                ? _c("span", [
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.get2FASilent(
                                              _vm.sendAgainPIN,
                                              _vm.newPassword ||
                                                _vm.loginFields.password
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "MyAccount.Login.2fa.Sent.Pin.Again"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(".\n          ")
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.trustDeviceVisible
                          ? _c("div", [
                              _c(
                                "div",
                                { staticClass: "checkbox-holder" },
                                [
                                  _c(
                                    "v-checkbox",
                                    {
                                      attrs: {
                                        id: "cbTrustDevice",
                                        type: "checkbox"
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.changeTrust()
                                        }
                                      },
                                      model: {
                                        value: _vm.trustDevice,
                                        callback: function($$v) {
                                          _vm.trustDevice = $$v
                                        },
                                        expression: "trustDevice"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "label" },
                                          slot: "label"
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "MyAccount.Login.2fa.Trust.Device"
                                                )
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.verifiedChannels
                          ? _c("div", { staticClass: "verified-channels" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "verified-channels__expand",
                                  on: {
                                    click: function($event) {
                                      _vm.verChannels = !_vm.verChannels
                                    }
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Account.Authentication.2fa.Channel.Pin.NotReceiving"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  !_vm.verChannels
                                    ? _c(
                                        "span",
                                        [
                                          _c(
                                            "v-icon",
                                            { staticClass: "chevron_down" },
                                            [_vm._v("expand_more")]
                                          )
                                        ],
                                        1
                                      )
                                    : _c(
                                        "span",
                                        [
                                          _c(
                                            "v-icon",
                                            { staticClass: "chevron_up" },
                                            [_vm._v("expand_less")]
                                          )
                                        ],
                                        1
                                      )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.verChannels
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "verified-channels__content"
                                    },
                                    [
                                      _vm.verifiedChannels.length === 1
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "Account.Authentication.2fa.Channel.Pin.Receiving.OneChannel"
                                                )
                                              )
                                            )
                                          ])
                                        : _c("span"),
                                      _vm._v(" "),
                                      _vm._l(_vm.verifiedChannels, function(
                                        ch
                                      ) {
                                        return _c("div", [
                                          _c(
                                            "a",
                                            {
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.get2FA(
                                                    ch,
                                                    _vm.newPassword
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              ch.toLowerCase() === "pin"
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Account.Authentication.2fa.Channel.Pin.Receiving.PIN"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                : ch.toLowerCase() === "totp"
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Account.Authentication.2fa.Channel.Pin.Receiving.TOTP"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                : _c("span", [
                                                    _vm._v(_vm._s(ch))
                                                  ]),
                                              _vm._v(" "),
                                              _c("span")
                                            ]
                                          )
                                        ])
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.formSubmitSppiner
                    ? _c("div", [_c("circle-loader")], 1)
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.formSubmitSppiner
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "primary-btn-blue",
                          attrs: {
                            type: "submit",
                            disabled: !_vm.pin,
                            block: ""
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              _vm.showResetPwdSAForm
                                ? _vm.resetPwdSAMode()
                                : _vm.loginSA()
                            }
                          }
                        },
                        [
                          !(_vm.showResetPwdSAForm && _vm.ResetPwdSAPINOnLogin)
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.$t("MyAccount.LogIn")))
                              ])
                            : _c("span", [
                                _vm._v(_vm._s(_vm.$t("MyAccount.Proceed")))
                              ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.brandKey === "dn" || _vm.brandKey === "dnw"
            ? _c(
                "v-flex",
                {
                  staticClass: "close",
                  on: {
                    click: function($event) {
                      return _vm.closeLoginDialog()
                    }
                  }
                },
                [
                  _c(
                    "v-btn",
                    { staticClass: "close", attrs: { flat: "" } },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.$t("MyAccount.ContinueAsGuest")))])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b1962778", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1962778","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/LoginComponent.vue
// module id = null
// module chunks = 